
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/power-preparedness",
      function () {
        return require("private-next-pages/power-preparedness/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/power-preparedness"])
      });
    }
  